import { IntegrationType } from 'helpers/integration/IntegrationType';
import { BaseIntegrationProps } from '../../BaseIntegrationProps';

export class EtoIntegrationProps extends BaseIntegrationProps {
    private securityToken: string;
    private enterpriseGuid: string;
    protected integrationType = IntegrationType.ETO;

    constructor(root: HTMLElement) {
        super(root);
        this.securityToken = this.getAttribute('REACT_APP_ETO_SECURITY_TOKEN', 'data-security-token');
        this.enterpriseGuid = this.getAttribute('REACT_APP_ETO_ENTERPRISE_GUID', 'data-enterprise-guid');
        if (this.enterpriseGuid.length > 0) {
            this.tenantId = this.enterpriseGuid;
        }
    }

    getSessionHeaders(): { [key: string]: unknown; } {
        return {
            securitytoken: this.securityToken
        };
    }

    getProductAdminType(): string {
        return 'enterprise manager';
    }

    getMissingPropertyError(): Error | null {
        const error = super.getMissingPropertyError();
        if (error !== null) {
            return error;
        }
        if (!this.securityToken) {
            return new Error('Current Security Token is null');
        }
        if (!this.enterpriseGuid) {
            return new Error('Current Enterprise Guid is null');
        }
        return null;
    }
}
